import HomePage from "../dashboard/HomePage";
import CatalogPage from "../dashboard/CatalogePage";
import OrdersPage from "../dashboard/OrdersPage";
import PromotionsPage from "../dashboard/PromotionsPage";
import AnalyticsPage from "../dashboard/AnalyticsPage";
import SettingsPage from "../dashboard/SettingsPage";
import SupportPage from "../dashboard/SupportPage";
import AddProduct from "../pages/AddProduct";
import SellerEditProductPage from "../dashboard/SellerEditProductPage";
export const dashboardRoutes = [
  { path: "home", element: <HomePage /> },
  { path: "catalog", element: <CatalogPage /> },
  { path: "orders", element: <OrdersPage /> },
  { path: "promotions", element: <PromotionsPage /> },
  { path: "analytics", element: <AnalyticsPage /> },
  { path: "support", element: <SupportPage /> },
  { path: "settings", element: <SettingsPage /> },
  { path: "catalog/products/new", element: <AddProduct /> },
  { path: "catalog/products/:id/edit", element: <SellerEditProductPage /> },
];
